import { UuidTool } from "uuid-tool";

export function uniqueId() {
  const uuid = UuidTool.newUuid();
  const parsedUuid = UuidTool.toBytes(uuid);
  const buffer = Buffer.from(parsedUuid);
  return buffer.readUInt32BE(0);
}
